import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NxGridModule } from "@aposin/ng-aquila/grid";
import { NxLinkModule } from "@aposin/ng-aquila/link";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-auth-side-header",
  standalone: true,
  imports: [RouterModule, NxGridModule, NxLinkModule, TranslateModule],
  templateUrl: "./auth-side-header.component.html",
  styleUrls: ["./auth-side-header.component.scss"],
})
export class AuthSideHeaderComponent {}
